module.exports = __webpack_public_path__ + "static/media/Tilburg-Pic.79becad1.jpg";